<template>
  <v-btn
    class="mx-1"
    :href="referralLink"
    target="_blank"
    @click="captureReferralLink('referrallink_howto', referralLink); return false;"
    outlined
    small
    ><slot>https://wisetoken.net</slot>
  </v-btn>
</template>

<script>
import config from "@/utils/config.json";

export default {
  name: "ReferralLink",

  data() {
    return {
      referralAccount: config.referralAccount
    };
  },
  computed: {
    referralLink() {
      return "https://wisetoken.net/?w=" + config.referralAccount;
    },
  },
  methods: {
    captureReferralLink(category, url) {
      this.$ga.event(category, 'click', url, 1234);
    }
  }
};
</script>
